"use client"

import { useState, useEffect } from "react"

// interface UseLoadingStateProps {
//   isLoading: boolean
//   loadingDuration?: number
// }

export function useLoadingState({ isLoading, loadingDuration = 1500 }) {
    const [internalLoading, setInternalLoading] = useState(isLoading)
    const [showContent, setShowContent] = useState(!isLoading)

    useEffect(() => {
        if (isLoading) {
            setInternalLoading(true)
            setShowContent(false)
        } else {
            // 模擬最小loading時間，確保用戶能看到loading狀態
            const timer = setTimeout(() => {
                setInternalLoading(false)
                // 稍微延遲顯示內容，讓過渡更平滑
                setTimeout(() => setShowContent(true), 100)
            }, loadingDuration)

            return () => clearTimeout(timer)
        }
    }, [isLoading, loadingDuration])

    return { internalLoading, showContent }
}
